export const ProductBlockTypes = {
  IProductBlockService: Symbol("IProductBlockService"),
};
